// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem_menuItem__8DrwV","active":"MenuItem_active__1Ln_O","button":"MenuItem_button__2fMv7"};